import { Box, Container, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';

import Hidden from '../ui/TzoHidden';

const CardForms = () => {
  return (
    <>
      <Container
        maxWidth="xl"
        sx={{
          pt: 2,
          mt: 2,
          '& .card__content': {
            animation: 'scale linear forwards',
            animationTimeline: 'view()',
            animationRange: '85vh 100vh',
          },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            textAlign: 'center',
            lineHeight: 1.3,
          }}
        >
          Easily file your IRS forms with confidence
          <Hidden smDown>
            <br />
          </Hidden>{' '}
          by using TaxZerone
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#333333',
            mb: 3,
            textAlign: 'center',
            maxWidth: 940,
            mx: 'auto',
          }}
        >
          TaxZerone is an IRS-authorized e-file service provider that helps
          businesses, individuals, tax professionals, and nonprofit
          organizations electronically file supported federal tax forms, related
          state tax filings, and other tax compliance forms.
        </Typography>

        {/* Excise Tax Forms Start */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: { xs: 'inherit', lg: 'sticky' },
            mt: 8,
            mb: 0,
            top: { md: 120, lg: 110, xl: 130 },
            // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
            minHeight: { md: 550, lg: 615, xs: 695 },
            borderRadius: 6,
            px: 5,
            py: 3,
            backgroundColor: '#e7f8ed',
            border: '10px solid #fff',
          }}
          className="card__content"
          component="article"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              width: '100%',
            }}
            spacing={{ xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }}
            alignItems="center"
            component="section"
            aria-labelledby="excise-tax-forms"
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
                minWidth: { sm: 230, lg: 460 },
                minHeight: { sm: 230, lg: 460 },
                borderRadius: 4,
              }}
            >
              <Image
                src="/assets/images/exc-img.webp"
                alt="Excise Tax Forms"
                width={460}
                height={460}
                loading="lazy"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    minWidth: { xs: 'inherit', sm: 60 },
                    minHeight: { xs: 'inherit', sm: 60 },
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    p: 0,
                    width: 60,
                  }}
                >
                  <img
                    src="/assets/images/excise-icon.png"
                    alt="Excise Tax Forms"
                    loading="lazy"
                    decoding="async"
                    fetchPriority="low"
                    width={60}
                    height={60}
                  />
                </Box>

                <Box sx={{}}>
                  <Typography
                    variant="h2"
                    id="excise-tax-forms"
                    sx={{
                      fontSize: { xs: 20, sm: 20, md: 22, lg: 24 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Excise Tax</span>
                    </span>{' '}
                    Forms
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ mb: 0, fontWeight: 500, color: '#475467' }}
                  >
                    Form 2290, Form 8849 (Schedule 6) & 2290 Amendments
                  </Typography>
                </Box>
              </Stack>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 18, lg: 20 },
                    fontWeight: 600,
                    mb: 0.5,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  File Your Heavy Vehicle{' '}
                  <Link
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/`}
                    style={{ color: '#0000CC' }}
                  >
                    Excise Taxes
                  </Link>{' '}
                  Online with Ease
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Whether you operate a{' '}
                  <span style={{ fontWeight: 600 }}> single truck</span> or{' '}
                  <span style={{ fontWeight: 600 }}>
                    manage an entire fleet,
                  </span>{' '}
                  TaxZerone makes HVUT filing simple and accurate. You can file,
                  amend, or claim refunds online.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 16, sm: 15, xs: 15 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  We Support:
                </Typography>
                <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}/excise-tax/file-irs-form-2290-by-phone/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Phone Filing
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 2290 – HVUT
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-8849-schedule-6-online/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 8849 (Schedule 6)
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/free-e-file-form-2290-suspended-vehicles/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 2290 - Suspended Vehicles
                      </Link>{' '}
                    </li>
                  </Box>
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-vin-correction-online/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        2290 VIN Correction Amendments [FREE]
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-weight-increased-amendment/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        2290 Weight Increase Amendments
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-mileage-exceeded-amendment/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        2290 Mileage Exceeded Amendments
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/form-2290-mobile-app/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        2290 - Mobile App
                      </Link>{' '}
                    </li>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Box>
        {/* Excise Tax Forms End */}
        {/* Business Tax Forms Start */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: { xs: 'inherit', lg: 'sticky' },
            mt: 8,
            mb: 0,
            top: { md: 120, lg: 110, xl: 130 },
            // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
            minHeight: { md: 550, lg: 615, xs: 695 },
            borderRadius: 6,
            px: 5,
            py: 3,
            backgroundColor: '#e8e1f5',
            border: '10px solid #fff',
          }}
          className="card__content"
          component="article"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              width: '100%',
            }}
            spacing={{ xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }}
            alignItems="center"
            component="section"
            aria-labelledby="business-tax-forms"
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
                minWidth: { sm: 230, lg: 460 },
                minHeight: { sm: 230, lg: 460 },
                borderRadius: 4,
              }}
            >
              <Box
                component="img"
                src="/assets/images/bus-tax-img.webp"
                alt="Business Tax Forms"
                width={460}
                height={460}
                loading="lazy"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    minWidth: { xs: 'inherit', sm: 60 },
                    minHeight: { xs: 'inherit', sm: 60 },
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    p: 0,
                    width: 60,
                  }}
                >
                  <img
                    src="/assets/images/business-icon-app.png"
                    alt="Business Tax Forms"
                    fetchPriority="low"
                    loading="lazy"
                    decoding="async"
                    width={60}
                    height={60}
                  />
                </Box>

                <Box sx={{}}>
                  <Typography
                    variant="h2"
                    id="business-tax-forms"
                    sx={{
                      fontSize: { xs: 20, sm: 20, md: 22, lg: 24 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Business Tax </span>
                    </span>{' '}
                    Forms
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ mb: 0, fontWeight: 500, color: '#475467' }}
                  >
                    1120-S & 1065
                  </Typography>
                </Box>
              </Stack>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 18, lg: 20 },
                    fontWeight: 600,
                    mb: 0.5,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  Manage{' '}
                  <Link href="/business-tax/" style={{ color: '#0000CC' }}>
                    {' '}
                    Business Tax Forms
                  </Link>{' '}
                  Easily with Secure Online Filing
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  File your{' '}
                  <span style={{ fontWeight: 600 }}> S corporation</span> or{' '}
                  <span style={{ fontWeight: 600 }}>Partnership return,</span>{' '}
                  including Schedule K-1 forms for shareholders and partners, to
                  report business income, deductions, credits, and ownership
                  allocations accurately.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 16, sm: 15, xs: 15 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  We Support:
                </Typography>

                <Stack spacing={2} direction="row">
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-irs-form-1120-s/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 1120-S{' '}
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-irs-form-1065-online/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 1065
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-california-form-100s/`}
                        style={{ color: '#0000CC' }}
                      >
                        CA FTB - Form 100S
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-california-form-565/`}
                        style={{ color: '#0000CC' }}
                      >
                        CA FTB - Form 565
                      </Link>{' '}
                    </li>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Box>
        {/* Business Forms End */}
        {/* Exempt Org. Forms Start */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: { xs: 'inherit', lg: 'sticky' },
            mt: 8,
            top: { md: 120, lg: 110, xl: 130 },
            // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
            minHeight: { md: 550, lg: 615, xs: 695 },
            borderRadius: 6,
            px: 5,
            py: 3,
            backgroundColor: '#f6e6ea',
            border: '10px solid #fff',
          }}
          className="card__content"
          component="article"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              width: '100%',
            }}
            spacing={{ xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }}
            alignItems="center"
            component="section"
            aria-labelledby="exempt-organization-forms"
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
                minWidth: { sm: 230, lg: 460 },
                minHeight: { sm: 230, lg: 460 },
                borderRadius: 4,
              }}
            >
              <Image
                src="/assets/images/expt-img.png"
                alt="Exempt Org. Forms"
                width={460}
                height={460}
                priority
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    minWidth: { xs: 'inherit', sm: 60 },
                    minHeight: { xs: 'inherit', sm: 60 },
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    p: 0,
                    width: 60,
                  }}
                >
                  <img
                    src="/assets/images/nonprofit-icon.png"
                    alt="Exempt Organizations Forms"
                    fetchPriority="low"
                    loading="lazy"
                    decoding="async"
                    width={60}
                    height={60}
                  />
                </Box>

                <Box sx={{}}>
                  <Typography
                    variant="h2"
                    id="exempt-organization-forms"
                    sx={{
                      fontSize: { xs: 20, sm: 20, md: 22, lg: 24 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Exempt Org.</span>
                    </span>{' '}
                    (990 Series) Forms
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ mb: 0, fontWeight: 500, color: '#475467' }}
                  >
                    990-N, 990-EZ, 990, 990-PF, 990-T, 5227, CA 199, 1120-POL
                  </Typography>
                </Box>
              </Stack>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 18, lg: 20 },
                    fontWeight: 600,
                    mb: 0.5,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  Smart Online Filing for{' '}
                  <Link
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/`}
                    style={{ color: '#0000CC' }}
                  >
                    Tax-Exempt Organization
                  </Link>{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  <span style={{ fontWeight: 600 }}>
                    Nonprofits, charities, trusts, and other tax-exempt
                    organizations
                  </span>{' '}
                  can conveniently manage and file their annual information
                  returns. We provide support for a broad range of exempt
                  organization forms, state filing requirements, schedules, and
                  related filings through a reliable and streamlined platform.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 16, sm: 15, xs: 15 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  We Support:
                </Typography>
                <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 990-N
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-ez/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 990-EZ
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      {' '}
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 990{' '}
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-pf/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 990-PF
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-1120-pol/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 1120-POL
                      </Link>{' '}
                    </li>
                  </Box>
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-t/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 990-T
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-5227/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 5227
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/efile-ftb-ca-form199-online/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form CA 199
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-schedules/`}
                        style={{ color: '#0000CC' }}
                      >
                        {' '}
                        All required 990 schedules & supporting forms
                      </Link>
                    </li>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Box>
        {/* Exempt Org. Forms End */}
        {/* Employment Tax Forms Start */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: { xs: 'inherit', lg: 'sticky' },
            mt: 8,
            top: { md: 120, lg: 110, xl: 130 },
            // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
            minHeight: { md: 550, lg: 615, xs: 695 },
            borderRadius: 6,
            px: 5,
            py: 3,
            backgroundColor: '#ddf3f6',
            border: '10px solid #fff',
          }}
          className="card__content"
          component="article"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              width: '100%',
            }}
            spacing={{ xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }}
            alignItems="center"
            component="section"
            aria-labelledby="employment-tax-forms"
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
                minWidth: { sm: 230, lg: 460 },
                minHeight: { sm: 230, lg: 460 },
                borderRadius: 4,
              }}
            >
              <Box
                component="img"
                src="/assets/images/emp-img.webp"
                alt="Employment Tax Forms"
                width={460}
                height={460}
                loading="lazy"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    minWidth: { xs: 'inherit', sm: 60 },
                    minHeight: { xs: 'inherit', sm: 60 },
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    p: 0,
                    width: 60,
                  }}
                >
                  <img
                    src="/assets/images/employment-icon.png"
                    alt="Employment Tax Forms"
                    fetchPriority="low"
                    loading="lazy"
                    decoding="async"
                    width={60}
                    height={60}
                  />
                </Box>

                <Box sx={{}}>
                  <Typography
                    variant="h2"
                    id="employment-tax-forms"
                    sx={{
                      fontSize: { xs: 20, sm: 20, md: 22, lg: 24 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Employment Tax</span>
                    </span>{' '}
                    (94X) Forms
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 0,
                      fontWeight: 500,
                      color: '#344054',
                    }}
                  >
                    941, 940, 943, 944, 945 & Related Amendment Forms
                  </Typography>
                </Box>
              </Stack>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 18, lg: 20 },
                    fontWeight: 600,
                    mb: 0.5,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  Simplify Your{' '}
                  <Link href="/employment-tax/" style={{ color: '#0000CC' }}>
                    {' '}
                    Employment Tax Forms
                  </Link>{' '}
                  Filing
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Designed for{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    small businesses, payroll providers, and tax professionals
                  </span>
                  , TaxZerone helps users handle quarterly, annual, and amended
                  employment tax filings through one centralized platform for
                  federal payroll tax reporting.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 16, sm: 15, xs: 15 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  We Support:
                </Typography>
                <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-941/`}
                        style={{ color: '#0000CC' }}
                      >
                        {' '}
                        Form 941{' '}
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-941-sp/`}
                        style={{ color: '#0000CC' }}
                      >
                        {' '}
                        Form 941-SP{' '}
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/efile-irs-form-941-x-online/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 941-X{' '}
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-941-schedule-r/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 941 Schedule R
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-940/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 940
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/efile-irs-form-940-amendment/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 940 Amendment
                      </Link>
                    </li>
                  </Box>
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-943/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 943
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-943-x/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 943-X
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-944/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 944
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-945/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 945
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-945-x/`}
                        style={{ color: '#0000CC' }}
                      >
                        Form 945-X
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-94x-pin-request/`}
                        style={{ color: '#0000CC' }}
                      >
                        94X PIN Request (FREE)
                      </Link>{' '}
                    </li>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Box>
        {/* Employment Tax Forms End */}
        {/* Extension Forms Start */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: { xs: 'inherit', lg: 'sticky' },
            mt: 8,
            top: { md: 120, lg: 110, xl: 130 },
            // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
            minHeight: { md: 550, lg: 615, xs: 695 },
            borderRadius: 6,
            px: 5,
            py: 3,
            backgroundColor: '#e6eaf7',
            border: '10px solid #fff',
          }}
          className="card__content"
          component="article"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              width: '100%',
            }}
            spacing={{ xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }}
            alignItems="center"
            component="section"
            aria-labelledby="extension-forms"
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
                minWidth: { sm: 230, lg: 460 },
                minHeight: { sm: 230, lg: 460 },
                aspectRatio: '1 / 1',
                borderRadius: 4,
              }}
            >
              <Box
                component="img"
                src="/assets/images/ext-img.webp"
                alt="Extension Forms"
                width={460}
                height={460}
                loading="lazy"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    minWidth: { xs: 'inherit', sm: 60 },
                    minHeight: { xs: 'inherit', sm: 60 },
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    p: 0,
                    width: 60,
                  }}
                >
                  <img
                    src="/assets/images/extension-icon.png"
                    alt="Extension Forms"
                    loading="lazy"
                    decoding="async"
                    width={60}
                    height={60}
                  />
                </Box>

                <Box sx={{}}>
                  <Typography
                    variant="h2"
                    id="extension-forms"
                    sx={{
                      fontSize: { xs: 20, sm: 20, md: 22, lg: 24 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax{' '}
                    <span className="highlight-container">
                      <span className="highlight">Extension</span>
                    </span>{' '}
                    Forms
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ mb: 0, fontWeight: 500, color: '#475467' }}
                  >
                    Form 7004, 4868, 8868, 8809 & 15397
                  </Typography>
                </Box>
              </Stack>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 18, lg: 20 },
                    fontWeight: 600,
                    mb: 0.5,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  Request Your{' '}
                  <Link
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/`}
                    style={{ color: '#0000CC' }}
                  >
                    Tax Extensions
                  </Link>{' '}
                  Online with Ease
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  TaxZerone allows{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    individuals, businesses, exempt organizations, and
                    transmitters
                  </span>{' '}
                  to electronically submit{' '}
                  <span style={{ fontWeight: 600 }}>
                    IRS-approved extension requests
                  </span>{' '}
                  when additional time is required to complete accurate filings.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 16, sm: 15, xs: 15 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  We Support:
                </Typography>
                <Stack spacing={2} direction="row">
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      {' '}
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-7004-business-tax-extension-online/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 7004
                      </Link>{' '}
                    </li>
                    <li>
                      {' '}
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-4868-personal-tax-extension-online/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 4868
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 8868
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-8809-online/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        {' '}
                        Form 8809{' '}
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/file-irs-form-15397-online/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 15397{' '}
                      </Link>
                    </li>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Box>
        {/* Extension Forms End */}
        {/* Information Returns Start */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: { xs: 'inherit', lg: 'sticky' },
            mt: 8,
            top: { md: 120, lg: 110, xl: 130 },
            // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
            minHeight: { md: 550, lg: 615, xs: 695 },
            borderRadius: 6,
            px: 5,
            py: 3,
            backgroundColor: '#dae6f6',
            border: '10px solid #fff',
          }}
          className="card__content"
          component="article"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              width: '100%',
            }}
            spacing={{ xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }}
            alignItems="center"
            component="section"
            aria-labelledby="information-returns"
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
                minWidth: { sm: 230, lg: 460 },
                minHeight: { sm: 230, lg: 460 },
                borderRadius: 4,
              }}
            >
              <Image
                src="/assets/images/inf-img.webp"
                alt="Information Returns"
                width={460}
                height={460}
                loading="lazy"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    minWidth: { xs: 'inherit', sm: 60 },
                    minHeight: { xs: 'inherit', sm: 60 },
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    p: 0,
                    width: 60,
                  }}
                >
                  <img
                    src="/assets/images/information-icon.png"
                    alt="Information Returns"
                    fetchPriority="low"
                    loading="lazy"
                    decoding="async"
                    width={60}
                    height={60}
                  />
                </Box>

                <Box sx={{}}>
                  <Typography
                    variant="h2"
                    id="information-returns"
                    sx={{
                      fontSize: { xs: 20, sm: 20, md: 22, lg: 24 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Information</span>
                    </span>{' '}
                    Returns
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ mb: 0, fontWeight: 500, color: '#475467' }}
                  >
                    W-2, W-2C, 1099, 1098, 1095, 3921, 3922, 5498, 1097-BTC and
                    W-2G Forms
                  </Typography>
                </Box>
              </Stack>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 18, lg: 20 },
                    fontWeight: 600,
                    mb: 0.5,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  E-File All Your{' '}
                  <Link
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/`}
                    style={{ color: '#0000CC' }}
                  >
                    Information Returns
                  </Link>{' '}
                  in One Place
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  TaxZerone provides a secure{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    IRS and SSA-authorized e-filing platform
                  </span>{' '}
                  for reporting{' '}
                  <span style={{ fontWeight: 600 }}>
                    wages, payments, healthcare coverage, investments, and
                    retirement contributions.
                  </span>
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 16, sm: 15, xs: 15 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  We Support:
                </Typography>
                <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}wage-tax-forms/`}
                        style={{ color: '#0000CC' }}
                      >
                        Wage & Tax Forms
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-series/`}
                        style={{ color: '#0000CC' }}
                      >
                        1099 Forms
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1098-series/`}
                        style={{ color: '#0000CC' }}
                      >
                        1098 Forms
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-5498-series/`}
                        style={{ color: '#0000CC' }}
                      >
                        5498 Forms
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>3921 & 3922 Form</li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1097-btc/`}
                        style={{ color: '#0000CC' }}
                      >
                        1097-BTC Form
                      </Link>
                    </li>
                  </Box>
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}aca-forms/`}
                        style={{ color: '#0000CC' }}
                      >
                        {' '}
                        ACA (1094/95) Forms
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1042-s/`}
                        style={{ color: '#0000CC' }}
                      >
                        1042-S Form
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/`}
                        style={{ color: '#0000CC' }}
                      >
                        W-2 State Filing
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/`}
                        style={{ color: '#0000CC' }}
                      >
                        1099 State Filing
                      </Link>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-w-2g/`}
                        style={{ color: '#0000CC' }}
                      >
                        W-2G Form
                      </Link>{' '}
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-corrections/`}
                        style={{ color: '#0000CC' }}
                      >
                        1099 Corrections
                      </Link>
                    </li>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Box>
        {/* Information Returns End */}
        {/* Essential Forms Start */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: { xs: 'inherit', lg: 'sticky' },
            mt: 8,
            mb: 8,
            top: { md: 120, lg: 110, xl: 130 },
            // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
            minHeight: { md: 550, lg: 615, xs: 695 },
            borderRadius: 6,
            px: 5,
            py: 3,
            backgroundColor: '#e5e4f7',
            border: '10px solid #fff',
          }}
          className="card__content"
          component="article"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              width: '100%',
            }}
            spacing={{ xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }}
            alignItems="center"
            component="section"
            aria-labelledby="essential-forms"
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
                minWidth: { sm: 230, lg: 460 },
                minHeight: { sm: 230, lg: 460 },
                borderRadius: 4,
              }}
            >
              <Box
                component="img"
                src="/assets/images/ess-img.webp"
                alt="Essential Forms"
                width={460}
                height={460}
                loading="lazy"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    minWidth: { xs: 'inherit', sm: 60 },
                    minHeight: { xs: 'inherit', sm: 60 },
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    p: 0,
                    width: 60,
                  }}
                >
                  <img
                    src="/assets/images/other-icon.png"
                    alt="Essential Forms"
                    loading="lazy"
                    decoding="async"
                    fetchPriority="low"
                    width={60}
                    height={60}
                  />
                </Box>

                <Box sx={{}}>
                  <Typography
                    variant="h2"
                    id="essential-forms"
                    sx={{
                      fontSize: { xs: 20, sm: 20, md: 22, lg: 24 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Essential</span>
                    </span>{' '}
                    Forms
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ mb: 0, fontWeight: 500, color: '#475467' }}
                  >
                    Form W-9, Form 8655 & FinCEN BOI Report
                  </Typography>
                </Box>
              </Stack>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 18, lg: 20 },
                    fontWeight: 600,
                    mb: 0.5,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  Forms for Taxpayer Identification and Authorization
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  For{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    businesses, individuals, reporting agents, and foreign
                    entities,
                  </span>{' '}
                  these forms simplify IRS and FinCEN reporting requirements,
                  whether providing taxpayer information, authorizing reporting
                  agents, or disclosing beneficial ownership.
                </Typography>

                <Stack spacing={2} direction="row">
                  <Box
                    component="ul"
                    sx={{
                      mb: 1,
                      ml: 1.5,
                      '& li': {
                        mb: 1.5,
                        listStyle: 'none',
                        position: 'relative',
                        pl: 3,
                        '&::before': {
                          content: '"✔"',
                          position: 'absolute',
                          left: 0,
                          top: 3,
                          color: 'black',
                          fontWeight: 'medium',
                          fontSize: '16px',
                          lineHeight: 1,
                        },
                      },
                    }}
                  >
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}request-form-w9-online-free/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form W-9
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}request-form-w8ben-online-free/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form W-8BEN
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-8655/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        Form 8655
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}efile-boi-report/`}
                        style={{ fontWeight: 600, color: '#0000CC' }}
                      >
                        BOIR
                      </Link>{' '}
                    </li>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Box>
        {/* Essential Forms End */}
      </Container>
    </>
  );
};

export default CardForms;
